import cn from "classnames";
import styles from './Compass.module.sass';

import Image from "next/image";
import {Objects, useGameContext} from "@/context/GameContext";
const Compass = ({parentStyle,className, ...props}) => {

	const {isMobile} = useGameContext()

	return (
		<div className={cn(styles.compass, className)} {...props}>
			{/*Compass*/}
			<Image className={parentStyle.compass__image} src={'/images/Game/Compass/compass.png'} alt={"Compass"} id={Objects.COMPASS} width={284} height={396}/>
			{/*Sparkles*/}
			{isMobile !== undefined ? (isMobile ? <Image className={parentStyle.compass__sparkles} src={'/images/Game/Glow/sparkles.png'} alt={"Sparkles"} width={64} height={64}/>
					: <Image className={parentStyle.compass__sparkles} src={'/images/Game/Glow/sparkles.gif'} alt={"Sparkles"} width={64} height={64}/>) : null}
		</div>
	)
}
export default Compass;